var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBbva(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0E2043",
    d: "M0 0h18v18H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillOpacity: 0.7,
    d: "m1.7 18 9.65-18H0v18h1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.064 12.913 8.857 7.6c.06-.113.232-.113.292 0l2.792 5.314a.156.156 0 0 0 .14.087h1.354a.122.122 0 0 0 .108-.179l-4.4-8.236c-.06-.113-.221-.113-.286 0l-4.4 8.236a.122.122 0 0 0 .108.179h1.353a.189.189 0 0 0 .146-.087Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.46952 -6.50002 6.98802 -8.0303 6.536 9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B5F9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B5F9D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbva);
export default __webpack_public_path__ + "static/media/bbva.1fb97bad1b5bc2e2a23897ff6077847a.svg";
export { ForwardRef as ReactComponent };